/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "flowExtensionLinkDefs",
    graphQL: "FlowExtensionLinkDef",
    name: "Flow Extension Link Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowExtensionLinkDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Extension Link Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flowDef) => {
                return flowDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        fromFlowDef: {
            name: "From Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            required: true,
            hiddenCreate: true,
        },
        fromFlowStepDef: {
            name: "Flow Step Definition",
            to: () => types['flowStepDefs'],
            type: "relation",
            required: true,
            relativeTo: ["fromFlowDef"],
        },
        toFlowDef: {
            name: "From Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            required: true,
            hiddenCreate: true,
        },
        toFlowStepDef: {
            name: "Flow Step Definition",
            to: () => types['flowStepDefs'],
            type: "relation",
            required: true,
            relativeTo: ["toFlowDef"],
        },
        key: {
            name: "Key",
            type: "string",
        },
        replaceAllLinks: {
            name: "Replace all links",
            type: "boolean",
            defaultValue: false,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
        },
        runOnError: {
            name: "Run on error",
            type: "boolean",
            defaultValue: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
});
